export default __webpack_public_path__ + "static/media/upload-icon.c73366c7.svg";